import { dictionaryService } from "../../../dataFlow";
import { useDictionaryItem, useParameter } from "../../../shared";
import { SLIDE_NUMBER } from "../constants";

export function useSlideTitle() {
  const [commoditiesDisplay] = useParameter("@commodities_display")
  const [_, commodityName] = useDictionaryItem(dictionaryService, "slides-commodities-display", commoditiesDisplay, {
    business_unit: 1,
    slide: SLIDE_NUMBER,
  });
  const title = commodityName && `Weekly crop commodity price reporting - ${commodityName[9]}`;
  return title || '';
}